//changed due to package upgrade
import React, { useEffect, useState ,useRef} from 'react';
import AppsContainer from '@projectK/components/AppsContainer';
import { useIntl } from 'react-intl';
import {
  alpha,
  Button,
  FormControl,
  useMediaQuery,
  useTheme,
    MenuItem,
  Select,
  Typography,
} from '@mui/material';
import AppsHeader from '@projectK/components/AppsHeader';
import AppsContent from '@projectK/components/AppsContent';
import AppsPagination from '@projectK/components/AppsPagination';
import Box from '@mui/material/Box';
import AppSearchBar from '@projectK/components/AppSearchBar';
import {
  PromoCodeTable,
  AddPromoCode,
  PromoCodeFilters,
} from '@projectK/modules/admin/PromoCodes';
import jwtAxios from '@projectK/services/auth/JWT';
import AppInfoView from '@projectK/components/AppInfoView';
import { useInfoViewActionsContext } from '@projectK/context/InfoViewContextProvider';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import IntlMessages from '@projectK/helpers/IntlMessages';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Fonts, tournamentAddon } from '@projectK/constants/AppEnums';
import { useAddonsSettings } from '@projectK/context/CheckAdddons';
import { useRolePermissions, hasPermission } from '@projectK/context/RolesProvider';

const PromoCodes = () => {
  const companyTheme = CompanyTheme();
  const { messages } = useIntl();
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const infoViewActionsContext = useInfoViewActionsContext();
  const [productOptions, setProductOptions] = useState([]);
  const [perPage, setPerPage] = useState(20);
  const [productFilter, setProductFilter] = useState('');
  const [startDateFilter, setStartDateFilter] = useState('');
  const [endDateFilter, setEndDateFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [tournamentFilter, setTournamentFilter] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const [nameSorting, setNameSorting] = useState(null);
  const [promoCodeSorting, setPromoCodeSorting] = useState(null);
  const [productNameSorting, setProductNameSorting] = useState(null);
  const [startDateSorting, setStartDateSorting] = useState(null);
  const [endDateSorting, setEndDateSorting] = useState(null);
  const [typeSorting, setTypeSorting] = useState(null);
  const [valueSorting, setValueSorting] = useState(null);
  const [statusSorting, setStatusSorting] = useState(null);
  const [tournamentOptions, setTournamentOptions] = useState(null);
  const [serviceTypeSorting, setServiceTypeSorting] = useState(null);
  const isMobile = useMediaQuery('(max-width:755px)');
  const { CheckAdddonsSettings } = useAddonsSettings();
  const { rolePermissions } = useRolePermissions();
  const abortControllerRef = useRef(null);
  const [exportLoading, setExportLoading] = useState(false);
  const handleChangePerPage = (event) => {
    const newPerPage = event.target.value;
    setPerPage(newPerPage);
    setPage(0);
  };
  useEffect(() => {
    fetchProductData();
  }, [search]);

  const hasTournamentAddon = CheckAdddonsSettings?.includes(tournamentAddon); // Check if tournament addon exists
  const fetchProductData = async () => {
    try {
      const response = await jwtAxios.get(`/products`, {
        params: {
          perPage: 'all',
          search,
        },
      });
      const { data } = response;
      setProductOptions(data.list);
    } catch (error) {
      setProductOptions([]);
    }
  };
  const fetchTournamentsData = async () => {
    try {
      const response = await jwtAxios.get('/tournament');

      setTournamentOptions(response.data.list);
    } catch (error) {
      setTournamentOptions([]);
    }
  };
  useEffect(() => {
    fetchTournamentsData();
  }, []);
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const onPageChange = (event, value) => {
    setPage(value);
  };
  useEffect(() => {
    fetchData();
   return () => {
      if (abortControllerRef.current) {
         abortControllerRef.current.abort();
      }
    };
  }, [
    search,
    page,
    perPage,
    productFilter,
    startDateFilter,
    endDateFilter,
    statusFilter,
    typeFilter,
    tournamentFilter,
    nameSorting,
    promoCodeSorting,
    productNameSorting,
    startDateSorting,
    endDateSorting,
    typeSorting,
    valueSorting,
    statusSorting,
    serviceTypeSorting,
  ]);

  const handleDelete = (itemId) => {
    // Make a DELETE request using jwtAxios and remove the item from the list
    jwtAxios
      .delete(`/promo-codes/${itemId}`)
      .then((response) => {
        // Remove the deleted item from the list
        setList(list.filter((item) => item.id !== itemId));
        fetchData();
        infoViewActionsContext.showMessage('Promo code deleted successfully!');
      })
      .catch((error) => {
        infoViewActionsContext.fetchError('Error deleting promo code.');
        console.error('Error deleting promo code:', error);
      });
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      abortControllerRef.current = new AbortController();
      const { signal } = abortControllerRef.current;
      const response = await jwtAxios.get(`/promo-codes`, {
        params: {
          search,
          page,
          perPage,
          filters: {
            product_id: productFilter,
            start_date: startDateFilter,
            end_date: endDateFilter,
            is_active: statusFilter,
            discount_type: typeFilter,
            tournament_id: tournamentFilter,
            source_type : hasTournamentAddon ? '' : 'products'
          },
          sortings: {
            promo_code_name: nameSorting,
            code: promoCodeSorting,
            product_name: productNameSorting,
            start_date: startDateSorting,
            end_date: endDateSorting,
            discount_type: typeSorting,
            discount_value: valueSorting,
            is_active: statusSorting,
            service_type: serviceTypeSorting,
          },
        },
        signal,
      });
      const { data } = response;
      setList(data.list);
      setTotal(data.total);
      data.list.length === 0 && page > 0 && setPage(page - 1);
      setLoading(false);
    } catch (error) {
      if (error.message !== 'canceled') {
          console.error('An error occurred:', error);
          setLoading(false);
      }
    }
  };

  const onSearchOrder = (value) => {
    setSearch(value);
    setPage(0);
  };
  const exportData = async () => {
    try {
      setExportLoading(true);
      const response = await jwtAxios.get(`/promo-codes/export/data`, {
        params: {
          page,
          filters: {
            product_id: productFilter,
            start_date: startDateFilter,
            end_date: endDateFilter,
            is_active: statusFilter,
            tournament_id: tournamentFilter,
            source_type : hasTournamentAddon ? '' : 'products',
            discount_type: typeFilter,
          },
          sortings: {
            promo_code_name: nameSorting,
            code: promoCodeSorting,
            product_name: productNameSorting,
            start_date: startDateSorting,
            end_date: endDateSorting,
            discount_type: typeSorting,
            discount_value: valueSorting,
            is_active: statusSorting,
          },
        },
      });
      const blob = new Blob([response.data], { type: `application/csv` });

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `promo-codes.csv`;
      link.click();
      setExportLoading(false);
    } catch (error) {
      infoViewActionsContext.fetchError(error.response.data.error);
      setExportLoading(false);
    }
  };
  return (
    <>
      <PromoCodeFilters
        setProductFilter={setProductFilter}
        productFilter={productFilter}
        setStartDateFilter={setStartDateFilter}
        startDateFilter={startDateFilter}
        setEndDateFilter={setEndDateFilter}
        endDateFilter={endDateFilter}
        setStatusFilter={setStatusFilter}
        statusFilter={statusFilter}
        setTypeFilter={setTypeFilter}
        typeFilter={typeFilter}
        setPage={setPage}
        productOptions={productOptions}
        tournamentFilter={tournamentFilter}
        setTournamentFilter={setTournamentFilter}
        tournamentOptions={tournamentOptions}
        hasTournamentAddon={hasTournamentAddon}
      />
      <br></br>
      <Typography
        variant='h4'
        className='mt-15'
        sx={{
          color: companyTheme ? companyTheme.primary.main : 'text.primary',
          fontWeight: Fonts.SEMI_BOLD,
        }}
      >
        <IntlMessages id='sidebar.admin.promoCodeSettings' />
      </Typography>
      <div className='event-search ps-h'>
        <AppsContainer fullView>
          <AppsHeader>
            <Box
              display='flex'
              flexDirection='row'
              alignItems='center'
              width={1}
              justifyContent='space-between'
              className='main-box'
            >
              <Box display='flex' flexDirection='row' className='search-box'>
                <AppSearchBar
                  iconPosition='right'
                  overlap={false}
                  onChange={(event) => onSearchOrder(event.target.value)}
                  placeholder={messages['common.searchHere']}
                />
              </Box>
              <Box
                display='flex'
                flexDirection='row'
                alignItems='center'
                className='button-boxes'
              >
                {hasPermission(rolePermissions, 'Company Settings - Promo Codes', 'create') && (
                <Button
                  variant='contained'
                  sx={{
                    backgroundColor: companyTheme
                      ? companyTheme.primary.main
                      : '#2196f3',
                    '&:hover': {
                      backgroundColor: companyTheme
                        ? alpha(companyTheme.primary.main, 0.8) // Adjust the alpha value as needed
                        : alpha('#2196f3', 0.8),
                    },
                  }}
                  onClick={openModal}
                >
                  Add Promo Code
                </Button>
                )}
               {hasPermission(rolePermissions, 'Company Settings - Promo Codes', 'export') && (
                  <Button
                    variant='outlined'
                    onClick={exportData}
                    sx={{
                      position: 'relative',
                      ...(isMobile ? { ml: 2.5 } : { ml: 1.5 }),
                      ...(isMobile ? { minWidth: 0 } : { minWidth: 160 }),
                      borderColor: companyTheme
                        ? companyTheme.primary.main
                        : '#2196f3',
                      '&:hover': {
                        borderColor: companyTheme
                          ? alpha(companyTheme.primary.main, 0.8)
                          : alpha('#2196f3', 0.8),
                      },
                      color: companyTheme
                        ? companyTheme.primary.main
                        : '#2196f3',
                      textTransform: 'none',
                    }}
                  >
                    {isMobile ? (
                      <FileDownloadOutlinedIcon sx={{ mr: 1 }} />
                    ) : (
                      <>
                        <FileDownloadOutlinedIcon sx={{ mr: 1 }} />
                        Export to CSV
                      </>
                    )}
                  </Button>
                )}
                {!isSmDown && (
                  <>                  <FormControl
                    variant='standard'
                    sx={{
                      borderRadius: 50,
                    }}
                    size='small'
                  >
                    <Select
                      value={perPage}
                      onChange={handleChangePerPage}
                      sx={{ marginLeft: '10px' }}
                    >
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={30}>30</MenuItem>
                      <MenuItem value={40}>40</MenuItem>
                      <MenuItem value={60}>60</MenuItem>
                      <MenuItem value={80}>80</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>
                  </FormControl>
                  <AppsPagination
                    rowsPerPage={perPage}
                    count={total}
                    page={page}
                    onPageChange={onPageChange}
                  />
                </>
                )}
              </Box>
            </Box>
          </AppsHeader>

          <AppsContent
            className='evnt-s-table ps-events'
            sx={{
              paddingTop: 2.5,
              paddingBottom: 2.5,
            }}
          >
            <PromoCodeTable
              promocodeData={list}
              loading={loading}
              onDelete={handleDelete}
              fetchData={fetchData}
              productOptions={productOptions}
              nameSorting={nameSorting}
              setNameSorting={setNameSorting}
              promoCodeSorting={promoCodeSorting}
              setPromoCodeSorting={setPromoCodeSorting}
              productNameSorting={productNameSorting}
              setProductNameSorting={setProductNameSorting}
              startDateSorting={startDateSorting}
              setStartDateSorting={setStartDateSorting}
              endDateSorting={endDateSorting}
              setEndDateSorting={setEndDateSorting}
              typeSorting={typeSorting}
              setTypeSorting={setTypeSorting}
              valueSorting={valueSorting}
              setValueSorting={setValueSorting}
              statusSorting={statusSorting}
              setStatusSorting={setStatusSorting}
              serviceTypeSorting={serviceTypeSorting}
              setServiceTypeSorting={setServiceTypeSorting}
              hasTournamentAddon={hasTournamentAddon}
              exportLoading={exportLoading}
            />
          </AppsContent>

          {!isSmUp && (
            <>            <FormControl
              variant='standard'
              sx={{
                borderRadius: 50,
              }}
              size='small'
              className='cols-count colc25'
            >
              <Select
                value={perPage}
                onChange={handleChangePerPage}
                sx={{ marginLeft: '10px', height: '34px' }}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
                <MenuItem value={40}>40</MenuItem>
                <MenuItem value={60}>60</MenuItem>
                <MenuItem value={80}>80</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
            <AppsPagination
              className='cols-pagination'
              rowsPerPage={perPage}
              count={total}
              page={page}
              onPageChange={onPageChange}
            />
          </>
          )}
          <AddPromoCode
            isOpen={isModalOpen}
            onClose={closeModal}
            fetchData={fetchData}
            productOptions={productOptions}
            tournamentOptions={tournamentOptions}
            hasTournamentAddon={hasTournamentAddon}
          />

          <AppInfoView />
        </AppsContainer>
      </div>
    </>
  );
};

export default PromoCodes;
